import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Footer from "./components/Footer";
import LandingPage from "./components/LandingPage";
import AboveFooter from "./components/AboveFooter";
import "./App.css";
import Header from "./components/Header";
import ScrollToTopButton from "./components/ScrollToTopButton";
import Impressum from "./components/Impressum.js"; // <--- NEU
import Datenschutz from "./components/Datenschutz.js";
import WhatsAppButton from "./components/WhatsAppButton.js";

function App() {
  const [showSecondaryNavbar, setShowSecondaryNavbar] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;

      if (scrollY > 0) setHasScrolled(true);

      const navbarHeight =
        document.querySelector(".navbar")?.offsetHeight || 0;
      if (scrollY > navbarHeight) setShowSecondaryNavbar(true);
      else setShowSecondaryNavbar(false);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
  <Router>
    <div className="main-container">
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header />
              <LandingPage />
              <AboveFooter />
              <Footer />
              <ScrollToTopButton />
            </>
          }
        />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
      </Routes>

      <WhatsAppButton />
    </div>
  </Router>
);
}

export default App;
